import StyleSelect from "../../../components/Button/AutoComplete";
import StyleInput from "../../../components/Button/Input";
import { parseDesc } from "../../../env";
import tabletrans from "../../../translate/tables";
import PostReq from "../../../utils/PostReq";
import { Autocomplete, TextField } from "@mui/material";
import { useState, useEffect } from "react";
function ProductSet(props) {
  const content = props.content;
  const def = content ? content.filter : "";
  const brand = content && content.brandList;
  const category = content && content.categoryList;
  const filterList = content && content.filterList;
  const [ProductList, setProductList] = useState();
  const removeMaster = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/product/editProduct",
      body: { productId: def._id, masterSku: "" },
    });
    window.location.reload();
  };
  const fetchProducts = async (search) => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/product/list-product",
      body: { title: search, pageSize: "10", offset: "0" },
    });
    setProductList(result.filter);
  };
  console.log(props.productChange);
  return (
    <div className="pd-row">
      <div className="row-title">
        <h4>نیم ست</h4>
        <p>{tabletrans.attributes[props.lang]}</p>
      </div>
      <div className="row-box">
        <div className="probs-wrapper">
          <div className="input-wrapper" style={{ flexDirection: "column" }}>
            <StyleSelect
              title="نیم ست"
              direction={props.direction}
              class={"formInput halfWidth"}
              defaultValue={
                content && content.filter.isComplex
                  ? { title: "بلی", value: 1 }
                  : { title: "خیر", value: 0 }
              }
              options={[
                { title: "بلی", value: 1 },
                { title: "خیر", value: 0 },
              ]}
              label={"title"}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  isComplex: e ? e.value : 0,
                }))
              }
            />

            {props.productChange?.isComplex ? (
              <Autocomplete
                multiple={true}
                options={ProductList || []}
                getOptionLabel={(option) => option.title || ""}
                onChange={(event, value) =>
                  props.setProductChange((prevState) => ({
                    ...prevState,
                    subSku: value.map((item) => item.sku), // فقط sku ها
                  }))
                }
                defaultValue={def?.subProduct || []}
                sx={{ minWidth: 250 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="محصولات نیم ست"
                    variant="outlined"
                    onChange={(e) => fetchProducts(e.target.value)}
                  />
                )}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProductSet;
